__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "phoenix_ui";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@aspendental/shared-utils", "1.26.0", () => (Promise.all([__webpack_require__.e(480), __webpack_require__.e(759)]).then(() => (() => (__webpack_require__(1480))))));
			register("@emotion/react", "11.11.3", () => (Promise.all([__webpack_require__.e(992), __webpack_require__.e(759), __webpack_require__.e(721)]).then(() => (() => (__webpack_require__(4721))))));
			register("@emotion/styled", "11.11.0", () => (Promise.all([__webpack_require__.e(759), __webpack_require__.e(771), __webpack_require__.e(470)]).then(() => (() => (__webpack_require__(470))))));
			register("@fullcalendar/core", "6.1.10", () => (Promise.all([__webpack_require__.e(37), __webpack_require__.e(297)]).then(() => (() => (__webpack_require__(3297))))));
			register("@fullcalendar/react", "6.1.10", () => (Promise.all([__webpack_require__.e(37), __webpack_require__.e(759), __webpack_require__.e(538), __webpack_require__.e(300), __webpack_require__.e(516)]).then(() => (() => (__webpack_require__(6516))))));
			register("@fullcalendar/resource-timegrid", "6.1.10", () => (Promise.all([__webpack_require__.e(37), __webpack_require__.e(297), __webpack_require__.e(544)]).then(() => (() => (__webpack_require__(1544))))));
			register("@mui/material", "5.15.4", () => (Promise.all([__webpack_require__.e(636), __webpack_require__.e(992), __webpack_require__.e(609), __webpack_require__.e(759), __webpack_require__.e(538), __webpack_require__.e(771), __webpack_require__.e(272), __webpack_require__.e(455)]).then(() => (() => (__webpack_require__(1609))))));
			register("@reactour/tour", "3.6.1", () => (Promise.all([__webpack_require__.e(831), __webpack_require__.e(759)]).then(() => (() => (__webpack_require__(9831))))));
			register("clsx", "2.1.0", () => (__webpack_require__.e(542).then(() => (() => (__webpack_require__(2542))))));
			register("date-fns", "2.30.0", () => (__webpack_require__.e(943).then(() => (() => (__webpack_require__(5638))))));
			register("launchdarkly-react-client-sdk", "3.0.10", () => (Promise.all([__webpack_require__.e(12), __webpack_require__.e(759)]).then(() => (() => (__webpack_require__(1012))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(759)]).then(() => (() => (__webpack_require__(3961))))));
			register("react-router-dom", "6.21.2", () => (Promise.all([__webpack_require__.e(138), __webpack_require__.e(759), __webpack_require__.e(538)]).then(() => (() => (__webpack_require__(7138))))));
			register("react", "18.2.0", () => (__webpack_require__.e(526).then(() => (() => (__webpack_require__(9526))))));
			register("urql", "4.0.6", () => (Promise.all([__webpack_require__.e(422), __webpack_require__.e(759)]).then(() => (() => (__webpack_require__(9422))))));
			register("zod", "3.22.4", () => (__webpack_require__.e(959).then(() => (() => (__webpack_require__(959))))));
			initExternal(8161);
			initExternal(923);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};